var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,9c0-3.906-3.198-7.064-7.119-6.999c-3.654,0.061-6.745,3.089-6.877,6.741    c-0.064,1.785,0.541,3.424,1.584,4.691C28.064,15.226,29,17.399,29,19.721V22h6v-1.943c0-2.477,0.979-4.799,2.51-6.747    C38.443,12.124,39,10.628,39,9z",
    style: {
      fill: "#FFCB57"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,52c0,2.757,2.243,5,5,5h12v4h-4v2h36v-2h-4v-4h12c2.757,0,5-2.243,5-5v-3H1V52z M44,61H20v-4h24    V61z M3,51h58v1c0,1.654-1.346,3-3,3H6c-1.654,0-3-1.346-3-3V51z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,16c0-1.654,1.346-3,3-3h16v-2H6c-2.757,0-5,2.243-5,5v31h2V16z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,11H42v2h16c1.654,0,3,1.346,3,3v31h2V16C63,13.243,60.757,11,58,11z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51,45 13,45 13,17 22,17 22,15 11,15 11,47 53,47 53,15 42,15 42,17 51,17   ",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,19.721V23h8v-2.942c0-2.1,0.794-4.219,2.296-6.129C39.411,12.511,40,10.807,40,9    c0-2.162-0.849-4.188-2.391-5.704C36.101,1.812,34.114,1,32.001,1c-0.045,0-0.091,0-0.137,0.001    c-4.184,0.069-7.709,3.526-7.858,7.705c-0.071,1.954,0.572,3.858,1.811,5.363C27.245,15.804,28,17.758,28,19.721z M34,21h-4v-1    h4.003c0,0.019-0.003,0.038-0.003,0.058V21z M31.897,3.001c1.634-0.035,3.154,0.584,4.31,1.721C37.363,5.859,38,7.378,38,9    c0,1.354-0.441,2.631-1.276,3.692c-1.302,1.655-2.149,3.46-2.515,5.308H33v-5h-2v5h-1.157c-0.326-1.83-1.165-3.603-2.482-5.203    c-0.928-1.127-1.41-2.554-1.357-4.02C26.116,5.645,28.76,3.053,31.897,3.001z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,25c-0.552,0-1-0.449-1-1h-2c0,1.654,1.346,3,3,3s3-1.346,3-3h-2C33,24.551,32.552,25,32,25z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 31,
    y: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,37c4.411,0,8-3.589,8-8c0-2.166-0.852-4.195-2.398-5.711l-1.4,1.428    C37.361,25.854,38,27.375,38,29c0,3.309-2.691,6-6,6s-6-2.691-6-6c0-1.58,0.608-3.071,1.714-4.198l-1.428-1.4    C24.812,24.905,24,26.894,24,29C24,33.411,27.589,37,32,37z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.781,43h-7.562l-0.722-2.887c-0.057-0.023-0.114-0.047-0.171-0.071l-2.553,1.531l-4.794-4.794    l1.414-1.414l3.69,3.69l2.122-1.273l0.484,0.231c0.32,0.153,0.646,0.289,0.982,0.407l0.508,0.179L29.781,41h4.438l0.601-2.401    l0.508-0.179c0.336-0.118,0.662-0.254,0.982-0.407l0.484-0.231l2.122,1.273l3.139-3.138l-1.273-2.123l0.232-0.485    c0.152-0.318,0.288-0.646,0.407-0.982l0.179-0.506l2.4-0.6v-4.438l-2.4-0.6l-0.179-0.506c-0.119-0.336-0.255-0.664-0.407-0.982    l1.803-0.864c0.105,0.219,0.204,0.443,0.296,0.669L46,25.219v7.562l-2.888,0.722c-0.023,0.058-0.047,0.114-0.07,0.171l1.53,2.553    l-5.346,5.346l-2.553-1.531c-0.057,0.024-0.114,0.048-0.171,0.071L35.781,43z",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.184,34.172c-0.105-0.219-0.204-0.443-0.296-0.669L18,32.781v-7.562l2.888-0.722    c0.023-0.058,0.047-0.114,0.07-0.171l-1.53-2.553l4.794-4.794l1.414,1.414l-3.69,3.69l1.273,2.123l-0.232,0.485    c-0.152,0.318-0.288,0.646-0.407,0.982L22.4,26.181l-2.4,0.6v4.438l2.4,0.6l0.179,0.506c0.119,0.336,0.255,0.664,0.407,0.982    L21.184,34.172z",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 5.999,
    style: {
      fill: "#E56565"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.9411 34.9289)",
    width: 2,
    x: 40.192,
    y: 16.808
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres2);
export default __webpack_public_path__ + "static/media/AIres2.d5f8bd2387d51b62381a2c727926df77.svg";
export { ForwardRef as ReactComponent };